import * as React from 'react';
const { Fragment, useCallback } = React;
import ActionScreen from '@seeneco-ui/core/components/action-screen';
import Spinner from '@seeneco-ui/core/components/spinner';
import Box from '@seeneco-ui/core/components/box';
import Typography from '@seeneco-ui/core/components/typography';

import ConnectedServicesList from '../connected-services-list';
import NotConnectedServicesList from '../not-connected-services-list';
import {
	ServicesLayout,
} from './styled';


export type IntegrationsEntryProps = {
	isFetching: boolean;
	cmsMap: Record<string, CashManagementSystem>;
	accountsList: Array<ExternalSystemAccount>;
	ssiMap: Record<string, SubsystemInstance>;
	resMap: Record<string, RemoteExternalService>;
	onAddAccount?: (cmsGUID: string) => void;
	onChangeAccount?: (account: ExternalSystemAccount) => void;
	onRemoveAccount?: (account: ExternalSystemAccount) => void;
};

const IntegrationsEntry: React.SFC<IntegrationsEntryProps> = (props) => {
	const {
		isFetching,
		accountsList,
		cmsMap,
		ssiMap,
		resMap,
		onAddAccount,
		onChangeAccount,
		onRemoveAccount,
	} = props;

	const handleAddAccount = useCallback((cmsGUID) => () => onAddAccount(cmsGUID), [isFetching]);
	const handleChangeAccount = useCallback((account) => () => onChangeAccount(account), [isFetching]);
	const handleRemoveAccount = useCallback((account) => () => onRemoveAccount(account), [isFetching]);

	const renderTitle = () => {
		const title = !isFetching && accountsList.length > 0
		?	<Fragment>
				<Typography.Title marginBottom='30px'>Интеграции</Typography.Title>
				<Typography.Subheading fontWeight={500}>Подключенные банки</Typography.Subheading>
			</Fragment>
		: <Typography.Title>Интеграции</Typography.Title>;

		return title;
	};

	return (
		<ActionScreen.Base
			renderHeader={(props) => (
				<ActionScreen.Header {...props}>
					{renderTitle()}
				</ActionScreen.Header>
			)}>
			{
				isFetching
				?	<Box
						width='100%'
						minHeight='300px'
						display='flex'
						justifyContent='center'
						alignItems='center'>
						<Spinner />
					</Box>
				: 
				<div>
					{
						accountsList.length > 0 &&
						<ServicesLayout>
							<ConnectedServicesList
								isFetching={isFetching}
								accountList={accountsList}
								cmsMap={cmsMap}
								resMap={resMap}
								ssiMap={ssiMap}
								onAdd={handleAddAccount}
								onChange={handleChangeAccount}
								onRemove={handleRemoveAccount}
							/>
						</ServicesLayout>
					}
					<ServicesLayout>
						<Typography.Subheading
							fontWeight={500}
							marginBottom='12px'>
							Доступные для подключения банки
						</Typography.Subheading>
						<NotConnectedServicesList
							isFetching={isFetching}
							accountList={accountsList}
							cmsMap={cmsMap}
							ssiMap={ssiMap}
							onAdd={handleAddAccount}
						/>
					</ServicesLayout>
				</div>
			}
		</ActionScreen.Base>
	);
}

IntegrationsEntry.displayName = 'IntegrationsEntry';
IntegrationsEntry.defaultProps = {};

export default IntegrationsEntry;
